<script>
export let headline;
export let description;
export let image;
export let video;
export let what;
export let tools;
export let where;
export let maxWidth;
</script>

<style>

</style>

<div class="LinkLayoutD">
    <div class="headline">{headline}</div>
    <div class="description">{description}</div>
    {#if what}
        <div class="what"><b>What I did:</b> {what}</div>
    {/if}
    {#if where}
        <div class="where"><b>Publication:</b> {where}</div>
    {/if}
    {#if tools}
        <div class="tools"><b>Tools:</b> {tools}</div>
    {/if}
    <div class="clear"></div>
</div>